export const en = {
  // ── App shell ──
  app: {
    connectionLost: 'Connection Lost — Reconnecting...',
  },

  // ── Spectra ──
  spectra: {
    'hot-cold': { left: 'Hot', right: 'Cold' },
    'big-small': { left: 'Big', right: 'Small' },
    'loud-quiet': { left: 'Loud', right: 'Quiet' },
    'fast-slow': { left: 'Fast', right: 'Slow' },
    'heavy-light': { left: 'Heavy', right: 'Light' },
    'bright-dim': { left: 'Bright', right: 'Dim' },
    'wet-dry': { left: 'Wet', right: 'Dry' },
    'hard-soft': { left: 'Hard', right: 'Soft' },
    'sharp-dull': { left: 'Sharp', right: 'Dull' },
    'sweet-sour': { left: 'Sweet', right: 'Sour' },
    'rough-smooth': { left: 'Rough', right: 'Smooth' },
    'deep-shallow': { left: 'Deep', right: 'Shallow' },
    'wide-narrow': { left: 'Wide', right: 'Narrow' },
    'thick-thin': { left: 'Thick', right: 'Thin' },
    'full-empty': { left: 'Full', right: 'Empty' },
    'old-young': { left: 'Old', right: 'Young' },
    'rich-poor': { left: 'Rich', right: 'Poor' },
    'happy-sad': { left: 'Happy', right: 'Sad' },
    'calm-excited': { left: 'Calm', right: 'Excited' },
    'simple-complex': { left: 'Simple', right: 'Complex' },
    'useless-essential': { left: 'Useless', right: 'Essential' },
    'dangerous-safe': { left: 'Dangerous', right: 'Safe' },
    'cheap-expensive': { left: 'Cheap', right: 'Expensive' },
    'weak-strong': { left: 'Weak', right: 'Strong' },
    'ugly-beautiful': { left: 'Ugly', right: 'Beautiful' },
    'stupid-smart': { left: 'Stupid', right: 'Smart' },
    'boring-interesting': { left: 'Boring', right: 'Interesting' },
    'fake-real': { left: 'Fake', right: 'Real' },
    'common-rare': { left: 'Common', right: 'Rare' },
    'bad-good': { left: 'Bad', right: 'Good' },
    'easy-difficult': { left: 'Easy', right: 'Difficult' },
    'soft-loud': { left: 'Soft', right: 'Loud' },
    'dark-light': { left: 'Dark', right: 'Light' },
    'low-high': { left: 'Low', right: 'High' },
    'short-tall': { left: 'Short', right: 'Tall' },
    'stale-fresh': { left: 'Stale', right: 'Fresh' },
    'vague-precise': { left: 'Vague', right: 'Precise' },
    'passionate-indifferent': { left: 'Passionate', right: 'Indifferent' },
    'bitter-savory': { left: 'Bitter', right: 'Savory' },
    'salty-spicy': { left: 'Salty', right: 'Spicy' },
    'cold-warm': { left: 'Cold', right: 'Warm' },
    'dull-shiny': { left: 'Dull', right: 'Shiny' },
    'fragile-durable': { left: 'Fragile', right: 'Durable' },
    'rigid-flexible': { left: 'Rigid', right: 'Flexible' },
    'chaotic-orderly': { left: 'Chaotic', right: 'Orderly' },
    'messy-tidy': { left: 'Messy', right: 'Tidy' },
    'noisy-peaceful': { left: 'Noisy', right: 'Peaceful' },
    'busy-slow': { left: 'Busy', right: 'Slow' },
    'risky-certain': { left: 'Risky', right: 'Certain' },
    'unfair-just': { left: 'Unfair', right: 'Just' },
    'cruel-kind': { left: 'Cruel', right: 'Kind' },
    'selfish-generous': { left: 'Selfish', right: 'Generous' },
    'cowardly-brave': { left: 'Cowardly', right: 'Brave' },
    'lazy-ambitious': { left: 'Lazy', right: 'Ambitious' },
    'shy-outgoing': { left: 'Shy', right: 'Outgoing' },
    'gloomy-cheerful': { left: 'Gloomy', right: 'Cheerful' },
    'serious-silly': { left: 'Serious', right: 'Silly' },
    'tense-relaxed': { left: 'Tense', right: 'Relaxed' },
    'urban-rural': { left: 'Urban', right: 'Rural' },
    'modern-ancient': { left: 'Modern', right: 'Ancient' },
  },

  // ── Landing screen ──
  landing: {
    title: 'Bangos',
    subtitle: 'A game of intuition and perception',
    createRoom: 'Create Room',
    joinRoom: 'Join Room',
  },

  // ── Create Room screen ──
  createRoom: {
    title: 'Create a Room',
    back: 'Back',
    createRoom: 'Create Room',
  },

  // ── Join Room screen ──
  joinRoom: {
    title: 'Join a Room',
    roomCodeLabel: 'Room Code',
    roomCodePlaceholder: 'e.g. ABC123',
    roomCodeHint: 'Enter the 6-character room code',
    joinAsSpectator: 'Join as Spectator',
    back: 'Back',
    joinRoom: 'Join Room',
  },

  // ── Display Name input ──
  displayName: {
    label: 'Your Name',
    placeholder: 'Enter your name',
    errorRequired: 'Display name is required',
    errorTooShort: 'Display name must be at least 2 characters',
    errorTooLong: 'Display name must be 20 characters or fewer',
  },

  // ── Room Code validation ──
  roomCode: {
    errorRequired: 'Room code is required',
    errorLength: 'Room code must be exactly 6 characters',
    errorInvalidChars: 'Room code contains invalid characters',
  },

  // ── Error banner ──
  errorBanner: {
    dismissAriaLabel: 'Dismiss error',
  },

  // ── Lobby screen ──
  lobby: {
    roomCodeHeading: 'Room Code',
    copyCode: '📋 Copy Code',
    copyLink: '🔗 Copy Link',
    copied: '✓ Copied',
    shareHint: 'Share with friends to join your game',
    blueTeam: 'Blue Team',
    redTeam: 'Red Team',
    noPlayersYet: 'No players yet',
    disconnected: '(disconnected)',
    players: 'Players',
    spectators: 'Spectators',
    waitingPlayers: 'Waiting for {remaining} more player{plural} to join... (minimum 2 players required)',
    ready: '✅ Ready',
    clickWhenReady: 'Click when ready',
    waitingForReady: 'Waiting for all players to be ready...',
    startGame: 'Start Game',
    submitSpectrum: '✏️ Submit Your Own Spectrum',
    cancel: 'Cancel',
    spectrumFormDescription:
      'Create a spectrum pair with two opposing concepts. Submitted spectra may appear in future rounds!',
    spectrumLeftPlaceholder: 'Left label (e.g. Hot)',
    spectrumRightPlaceholder: 'Right label (e.g. Cold)',
    submitSpectrumBtn: 'Submit Spectrum',
    leaveRoom: 'Leave Room',
  },

  // ── In-game header ──
  gameHeader: {
    title: 'Bangos',
    round: 'Round',
    activeTeam: 'Active Team',
    blueShort: '🔵 Blue',
    redShort: '🔴 Red',
    helpTitle: 'Show tutorial',
    helpAriaLabel: 'Show tutorial',
    spectatorNotice: 'You are spectating. Watch the game unfold!',
  },

  // ── Scoreboard ──
  scoreboard: {
    blue: 'Blue',
    red: 'Red',
  },

  // ── Guessing slider ──
  guessingSlider: {
    position: 'Position',
    confirmGuess: 'Confirm Guess',
    waiting: 'Waiting...',
    guessSubmitted: 'Guess submitted at position {position}',
  },

  // ── Psychic view ──
  psychic: {
    spectrumTitle: 'Spectrum',
    dialPosition: 'Dial position: {pos}',
    psychicNotice: 'You are the psychic! Think of a clue related to the spectrum.',
    cluePlaceholder: 'Enter your clue (one word or short phrase)',
    submit: 'Submit',
    yourClue: 'Your clue: {clue}',
    activeTeamGuessing: 'The active team is positioning their guess...',
    psychicBadge: 'Psychic',
  },

  // ── Guesser view ──
  guesser: {
    spectrumTitle: 'Spectrum',
    psychicThinking: 'The psychic is thinking of a clue...',
    psychicsClue: "Psychic's clue: {clue}",
    guessSubmittedWaiting: 'Your guess has been submitted. Waiting for other team members...',
    activeTeamGuessing: 'The active team is positioning their guess...',
  },

  // ── Reveal screen ──
  reveal: {
    title: '🎯 Round Revealed!',
    readyForNext: 'Ready for Next Round',
    waitingForOthers: 'Waiting for others...',
    readyCount: '{ready}/{total} ready',
    spectrumTitle: 'Spectrum',
    clue: 'Clue: {text}',
    yourGuess: 'Your Guess',
    targetPosition: 'Target Position',
    distance: 'Distance',
    pointsEarned: 'Points Earned',
  },

  // ── Game Over screen ──
  gameOver: {
    title: '🎮 Game Over!',
    blueWins: '🔵 Blue Team Wins!',
    redWins: '🔴 Red Team Wins!',
    draw: "🤝 It's a Draw!",
    blueTeam: 'Blue Team',
    redTeam: 'Red Team',
    roundRecap: '📋 Round Recap',
    round: 'Round {num}',
    clue: 'Clue',
    clueValue: 'Clue: {text}',
    targetPosition: 'Target Position',
    guessPosition: 'Guess Position',
    distance: 'Distance',
    points: 'Points',
    playAgain: 'Play Again',
  },

  // ── Onboarding ──
  onboarding: {
    skip: 'Skip',
    gotIt: 'Got it!',
    back: '← Back',
    done: 'Done',
    next: 'Next →',
    step1Title: '🎯 Welcome to Bangos!',
    step1P1:
      'Bangos is a game of intuition and perception. Each round, one player becomes the **Psychic** who sees a secret target on a spectrum dial — and everyone else tries to guess where it is based on a single clue.',
    step1P2:
      'This quick tour will explain the core rules. You can reopen it anytime from the **?** icon.',
    step2Title: '🔮 The Psychic Role',
    step2P1:
      'Each round, a different player is chosen as the **Psychic**. Only the Psychic sees a **secret target position** on the spectrum dial (marked with a yellow glowing marker).',
    step2P2:
      'Your goal as Psychic is to think of a clue that hints at where the target is — without being too obvious or too vague.',
    step3Title: '💬 Giving a Clue',
    step3P1:
      'As the Psychic, you type a **single word or short phrase** (up to 50 characters) that relates to the spectrum shown.',
    step3P2:
      'For example, if the spectrum is _Hot — Cold_ and the target is near the "Hot" side, you might say **"Summer"** or **"Sun"**.',
    step3P3:
      'Press **Enter** or click **Submit** to send your clue.',
    step4Title: '🎚️ The Guessing Slider',
    step4P1:
      'The guessing team sees the clue and discusses where the target might be. One player from the active team uses the **slider** to submit the team\'s guess.',
    step4P2:
      '**Drag** the marker along the track, or **click** anywhere on the track to position it. Then click **Confirm Guess** to lock it in.',
    step5Title: '📊 Scoring',
    step5P1:
      'After the guess is submitted, the target is revealed. Points are scored based on how close the guess is to the target:',
    step5Li1: '**4 points** — ≤ 3 away (perfect!)',
    step5Li2: '**3 points** — ≤ 8 away',
    step5Li3: '**2 points** — ≤ 15 away',
    step5Li4: '**1 point** — anything else',
    step5P2:
      'The game lasts 8 rounds. The team with the most points at the end wins!',
  },

  // ── PWA Install prompt ──
  installPrompt: {
    message: 'Install Bangos for the best experience!',
    install: 'Install',
    notNow: 'Not now',
  },
} as const;
